import { fetchVacationPackagesDiscoveryRails } from "../services/vacationPackagesDiscoveryFetch";
import { fetchVacationPackagesHomeFeedFromDedicatedEndpoint } from "../services/vacationPackagesHomeFeedAdapter";
import {
  mergeDiscoveryHomeCachePartial,
  writeDiscoveryHomeCacheFull,
} from "./vacationPackagesHomeDiscoveryCache";
import { runDedupedDiscovery } from "./vacationPackagesDiscoveryInflight";

/**
 * טרום-טעינה לעמוד /vacation-packages (מילוי מטמון).
 * בטוח לקרוא מ-onMouseEnter / onFocus — לא זורק החוצה.
 */
export function prefetchVacationPackagesDiscoveryHome() {
  if (typeof window === "undefined") return;
  runDedupedDiscovery("prefetchFull", async () => {
    try {
      const ac = new AbortController();
      const fromApi = await runDedupedDiscovery("homeFeed", () =>
        fetchVacationPackagesHomeFeedFromDedicatedEndpoint(ac.signal)
      );
      if (fromApi) {
        mergeDiscoveryHomeCachePartial({ flights: fromApi.flights ?? [] });
        return;
      }
      const legacy = await fetchVacationPackagesDiscoveryRails();
      writeDiscoveryHomeCacheFull(legacy);
    } catch {
      /* שקט — העמוד יטען כרגיל */
    }
  });
}
